import { render, staticRenderFns } from "./ProductSlot.vue?vue&type=template&id=c8e35876&scoped=true&lang=pug"
import script from "./ProductSlot.vue?vue&type=script&lang=js"
export * from "./ProductSlot.vue?vue&type=script&lang=js"
import style0 from "./ProductSlot.vue?vue&type=style&index=0&id=c8e35876&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e35876",
  null
  
)

export default component.exports